import { useAdReady } from "@/lib/useAdReady";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";
import { Card, CardContent } from "@/components/ui/card";
import { COMPANY, overOnsContent } from "@/data/legalPages";

export default function OverOns() {
  useAdReady();
  return (
    <>
      <SEOHead
        title="Over ons | Theorieaanbieders.nl"
        description="Theorieaanbieders.nl is een onafhankelijk informatieplatform van 1's Visions uit Tilburg voor het vergelijken van rijscholen, theorie en opleiders in Nederland."
        canonicalUrl="https://theorieaanbieders.nl/over-ons"
      />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 container mx-auto px-4 pt-24 pb-12">
          <div className="max-w-3xl mx-auto space-y-6">
            <h1 className="text-4xl font-bold">{overOnsContent.title}</h1>
            {overOnsContent.sections.map((s) => (
              <Card key={s.heading}>
                <CardContent className="p-6 space-y-4 text-foreground/80 leading-relaxed">
                  <h2 className="text-2xl font-bold text-foreground">{s.heading}</h2>
                  {s.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
                </CardContent>
              </Card>
            ))}
            <Card>
              <CardContent className="p-6 space-y-2 text-foreground/80">
                <h2 className="text-2xl font-bold text-foreground mb-2">Bedrijfsgegevens</h2>
                <p>Theorieaanbieders.nl is een handelsnaam van <strong>{COMPANY.name}</strong>.</p>
                <p>{COMPANY.street}<br />{COMPANY.postal}</p>
                <p>KvK-nummer: {COMPANY.kvk}</p>
                <p>E-mail: {COMPANY.email}</p>
              </CardContent>
            </Card>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}
